import axiosConfig from "../../../../../config/axiosConfig";

const API = () => {
    const getTodoTaskNumber = async (params: any = {}) => {
        const url = "/todo-task/count";
        return (await axiosConfig.get(url, { params })).data;
    };

    return {
        getTodoTaskNumber,
    };
};

export default API;
